// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"341":"84bbdf60","513":"77527af9","787":"33fa5de9"}[chunkId] + ".chunk.js";
};